import React from "react";

const UploadsLinks = ({ userUploads, username }) => {
    if (username && userUploads) {
        return (
            <div className="back-link">
                {userUploads.hasApprovedUploads ? (
                    <a href="/dashboard/uploads">View All Uploads</a>
                ) : null}
                {userUploads.pendingCount ? (
                    <a href={`/${username}/uploads/pending`}>
                        {userUploads.pendingCount} Awaiting Moderation
                    </a>
                ) : null}
                {userUploads.deniedCount ? (
                    <a href={`/${username}/uploads/denied`}>
                        {userUploads.deniedCount} Denied
                    </a>
                ) : null}
            </div>
        );
    }

    return null;
};

export default UploadsLinks;
